import { FC } from 'react';
import { Typography, Button, ButtonGroup } from '@material-ui/core';
import { IconArrow } from '@clari/iris-icons';
import cx from 'classnames';

const LoaderSortButton: FC = () => {
  return (
    <ButtonGroup>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        classes={{
          root: cx(
            'ml-4 h-[32px] min-h-[32px] w-[64px] min-w-[64-px] items-baseline'
          ),
        }}
      >
        <div className="flex items-center justify-center mr-2 pt-[2px]">
          <Typography variant="body2" className="py-[2px]">
            Sort
          </Typography>
        </div>
      </Button>
      <Button
        color="primary"
        variant="contained"
        classes={{
          root: 'h-[32px] min-h-[32px] p-0 w-[32px] min-w-[32px]',
        }}
        size="small"
      >
        <IconArrow direction={'up'} />
      </Button>
    </ButtonGroup>
  );
};

export default LoaderSortButton;
